import { ToggleComponent } from '../../../../featureToggle';
import { RegisterMessage } from './RegisterMessage';

export default ToggleComponent(RegisterMessage, {
  styledComponentsVariants: {
    'fresh-watch': () => null,
  },
});
